import {Food} from "./types";

const OutbackSteakhouse: Food = {
    "Steak Fajita": {
        "Blackened Steak": "4.5oz",
        "Brown Rice": "5oz (WHITE scoop)",
        "Fajita Peppers & Onions": "2.5oz"
    },
    "Steakhouse Supreme": {
        "Petite Filet": "4.5oz",
        "Garlic Roasted Pots": "4.5",
        "Roasted Broccoli": "2.5oz",
        "Sides": "Aioli"
    },
    "Classic Meatloaf": {
        "Meatloaf": "5oz",
        "Mashed Potatoes": "4.5oz (GREY scoop)",
        "Roasted Green Beans": "2.5oz"
    },
     "Burger Bowl": {
        "Romaine Lettuce": "5oz",
        "Breakfast Potatoes": "4.5oz (GREY scoop)",
        "Side of Pickles": "5oz",
        "Cheddar Cheese": "4.5oz (GREY scoop)",
        "Beef": "2.5oz"
    },
        "Korean Beef Bowl": {
        "Bulgogi Beef": "4.2",
        "Blanch Broccoli": "2.5",
        "Jasmine Rice": "4.5 (GREY scoop)"
    },
        "Teriyaki Steak": {
        "Teriyaki Steak": "4.5oz",
        "Jasmine Rice": "4.5oz (Grey scoop)",
        "Roasted Broccoli": "1.3oz",
        "Roasted Carrots": "1.3oz",
        "Garnish": "Teriyaki Glaze, Green Onions, Roasted Sesame Seeds"
    }
}

export default OutbackSteakhouse